'use strict';

const config = {
    languageToggleSelector: '.js-newsletter-toggle',
    languageContentSelector: '.o-preferred-lang',
    hiddenClass: 'is-hidden'
};

$(config.languageToggleSelector).on('click', function() {
    $(config.languageContentSelector).toggleClass(config.hiddenClass, !$(this).is(':checked'));
});



// WEBPACK FOOTER //
// ./src/js/components/newsletter-language-toggle.js